/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 06:41:08
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-06 09:36:58
 */
import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { HeaderOption } from './model';

@Component({
  selector: 'ad-section-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input()
  option: HeaderOption;
  @Input() branding: string;
  @Input() logoUrl: string;
  @Input() rightToolTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void { }
}
